import { render, staticRenderFns } from "./search-selection.vue?vue&type=template&id=0006d26c&"
import script from "./search-selection.vue?vue&type=script&lang=js&"
export * from "./search-selection.vue?vue&type=script&lang=js&"
import style0 from "./search-selection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports